import type { LegacyTableProps } from "@wayflyer/flyui-dataviz";
import { Callout, LegacyPageBreadcrumb, EmptyState, Tabs } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

import type { PerformanceTable } from "../../../interface";
import { InsightsDataTable } from "../../../components/insights-data-table";
import { ErrorContainer, Spinner } from "../../../components/styled";

export interface GenericAdsPerformanceTableProps {
  performanceBreakdownData: PerformanceTable[];
  campaignPerformanceLoading?: boolean;
  campaignPerformanceError?: string;
  onSelectCampaignLink?: LegacyTableProps["onClickLink"];
  selectedTabIndex?: number;
  onSelectTab?: (title: string, tabIndex: number) => void;
}

/**
 * GenericAdsPerformanceTable component
 */
export const GenericAdsPerformanceTable = ({
  performanceBreakdownData,
  campaignPerformanceLoading = false,
  campaignPerformanceError = "",
  onSelectCampaignLink = () => {},
  selectedTabIndex = 0,
  onSelectTab = () => {},
}: GenericAdsPerformanceTableProps) => {
  const campaignPerformanceLoaded = !campaignPerformanceLoading && !campaignPerformanceError;
  const intl = useIntl();
  const noData = intl.formatMessage({ id: "Generic ads no Data", defaultMessage: "No Data" });

  return (
    <Tabs
      tabs={performanceBreakdownData.map((campaignPerformanceTableProps) => {
        return {
          title: campaignPerformanceTableProps.campaignType,
          content: (
            <>
              {campaignPerformanceTableProps.breadcrumb ? (
                <LegacyPageBreadcrumb {...campaignPerformanceTableProps.breadcrumb} />
              ) : null}
              {campaignPerformanceLoaded && campaignPerformanceTableProps.tableData ? (
                <InsightsDataTable {...campaignPerformanceTableProps.tableData} onClickLink={onSelectCampaignLink} />
              ) : null}
              {campaignPerformanceLoaded && !campaignPerformanceTableProps.tableData ? (
                <EmptyState text={noData} />
              ) : null}
              {campaignPerformanceLoading && !campaignPerformanceError ? <Spinner /> : null}
              {campaignPerformanceError ? (
                <ErrorContainer>
                  <Callout variant="critical" description={campaignPerformanceError} />
                </ErrorContainer>
              ) : null}
            </>
          ),
          disabled: campaignPerformanceTableProps.disabled,
        };
      })}
      selectedTabIndex={selectedTabIndex}
      onSelectTab={onSelectTab}
    />
  );
};
